import { render, staticRenderFns } from "./MyNewsletter.vue?vue&type=template&id=19bed454&scoped=true"
import script from "./MyNewsletter.vue?vue&type=script&lang=js"
export * from "./MyNewsletter.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./MyNewsletter.vue?vue&type=style&index=0&id=19bed454&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "19bed454",
  "0a6633d6"
  
)

export default component.exports